// 服务统计列表
export const serviceStatsList = [
  {
    label: '签收提醒',
    key: 'signRemindCnt',
    unit: '次'
  },
  {
    label: '用药提醒',
    key: 'medicationRemindCnt',
    unit: '次'
  },
  {
    label: '随访',
    key: 'followupCnt',
    unit: '次'
  },
  {
    label: '问卷收集',
    key: 'questionnaireCnt',
    unit: '次'
  },
  {
    label: '复诊提醒',
    key: 'returnVisitRemindCnt',
    unit: '次'
  },
  {
    label: '语音科普',
    key: 'voiceCnt',
    unit: '次'
  },
  {
    label: '专属医助',
    key: 'customerServiceCnt',
    unit: '次'
  }
]
